import styled from 'styled-components';
import { Typ20, Typ21 } from '../Typ';
import Lab010 from '../Lab010';
import ToolTip01 from '../ToolTip01';

export const TypographyWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`;

export const Caption2Normal = styled(Typ20)`
  color: ${props => props.color};
`;

export const Caption2Strong = styled(Typ21)`
  color: ${props => props.color};
`;

export const ParticipantValue = styled(Typ21)`
  margin-right: 6px;
  color: ${props => props.color};
`;

export const TypoText = styled(Typ20)`
  color: #607d8b;
  margin-left: 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  white-space: nowrap;
`;

export const LabelSmall = styled(Lab010)`
  margin-right: 6px;
  color: ${props => (props.position === 1 ? '#FFC107' : '#607D8B')};
`;

export const OptionWrapper = styled.div`
  margin-left: auto;
  display: flex;
  align-self: flex-end;
`;

export const ToolTip = styled(ToolTip01)`
  width: 100%;
`;
